import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthProviderCard, FormField, SetupAccordion } from '../components';
export function GoogleSAMLSection({ enabled, entityId, ssoUrl, certificate, emailAttribute, authServiceUrl, tenantSlug, onToggle, onEntityIdChange, onSsoUrlChange, onCertificateChange, onEmailAttributeChange }) {
    return /*#__PURE__*/ _jsxs(AuthProviderCard, {
        title: "Google Workspace SAML SSO",
        description: "Enterprise Google Workspace authentication via SAML 2.0",
        enabled: enabled,
        onToggle: onToggle,
        children: [
            /*#__PURE__*/ _jsx(SetupAccordion, {
                title: "📋 Guide me through setup",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 1: Configure Google Workspace"
                                }),
                                /*#__PURE__*/ _jsxs("ol", {
                                    className: "list-decimal list-inside space-y-2 ml-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Sign in to",
                                                ' ',
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: "https://admin.google.com",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "text-blue-600 hover:underline",
                                                    children: "Google Admin Console"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Navigate to ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Apps → Web and mobile apps"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Add app → Add custom SAML app"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Enter your app name and click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Continue"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                'On the "Google IdP Information" page:',
                                                /*#__PURE__*/ _jsxs("ul", {
                                                    className: "list-disc list-inside ml-4 mt-1 space-y-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("li", {
                                                            children: [
                                                                "Copy the ",
                                                                /*#__PURE__*/ _jsx("strong", {
                                                                    children: "SSO URL"
                                                                }),
                                                                ' - paste it into the "SSO URL" field below'
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("li", {
                                                            children: [
                                                                "Copy the ",
                                                                /*#__PURE__*/ _jsx("strong", {
                                                                    children: "Entity ID"
                                                                }),
                                                                ' - paste it into the "Entity ID" field below'
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("li", {
                                                            children: [
                                                                "Download the ",
                                                                /*#__PURE__*/ _jsx("strong", {
                                                                    children: "Certificate"
                                                                }),
                                                                ' - paste its contents into the "Certificate" field below'
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Continue"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 2: Configure Service Provider Details"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "bg-white border rounded p-3 space-y-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "text-xs font-medium text-gray-600 mb-1",
                                                    children: "ACS URL (Assertion Consumer Service URL):"
                                                }),
                                                /*#__PURE__*/ _jsxs("code", {
                                                    className: "text-xs bg-gray-100 px-2 py-1 rounded block break-all",
                                                    children: [
                                                        authServiceUrl,
                                                        "/api/auth/",
                                                        tenantSlug,
                                                        "/saml/google/acs"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "text-xs font-medium text-gray-600 mb-1",
                                                    children: "Entity ID (Service Provider Entity ID):"
                                                }),
                                                /*#__PURE__*/ _jsxs("code", {
                                                    className: "text-xs bg-gray-100 px-2 py-1 rounded block break-all",
                                                    children: [
                                                        authServiceUrl,
                                                        "/api/auth/",
                                                        tenantSlug,
                                                        "/saml/google/metadata"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "text-xs font-medium text-gray-600 mb-1",
                                                    children: "Start URL (optional):"
                                                }),
                                                /*#__PURE__*/ _jsxs("code", {
                                                    className: "text-xs bg-gray-100 px-2 py-1 rounded block break-all",
                                                    children: [
                                                        authServiceUrl,
                                                        "/api/auth/",
                                                        tenantSlug,
                                                        "/saml/google/sso"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-xs text-gray-600 mt-2",
                                    children: "Copy these URLs and paste them into Google Workspace SAML configuration."
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 3: Configure Attribute Mapping"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    children: "In Google Workspace, ensure the following attribute is mapped:"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "list-disc list-inside ml-2 mt-1",
                                    children: /*#__PURE__*/ _jsxs("li", {
                                        children: [
                                            /*#__PURE__*/ _jsx("strong", {
                                                children: "Primary email"
                                            }),
                                            " →",
                                            ' ',
                                            /*#__PURE__*/ _jsx("code", {
                                                className: "text-xs bg-gray-100 px-1 py-0.5 rounded",
                                                children: "email"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 4: Assign Users"
                                }),
                                /*#__PURE__*/ _jsxs("ol", {
                                    className: "list-decimal list-inside space-y-1 ml-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "In Google Workspace SAML app settings, go to ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "User access"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: "Turn ON the service for users/groups who should have access"
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                "Click ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "Save"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "font-semibold text-gray-900 mb-2",
                                    children: "Step 5: Fill in Configuration Below"
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        "Copy the values from Step 1 and paste them into the configuration fields below, then click ",
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: "Save Changes"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "google-saml-entity-id",
                label: "Entity ID (IdP Entity ID)",
                value: entityId,
                onChange: onEntityIdChange,
                placeholder: "https://accounts.google.com/o/saml2?idpid=...",
                helpText: "Found in Google Workspace Admin Console → Apps → SAML apps",
                required: true
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "google-saml-sso-url",
                label: "SSO URL (Single Sign-On URL)",
                value: ssoUrl,
                onChange: onSsoUrlChange,
                placeholder: "https://accounts.google.com/o/saml2/idp?idpid=...",
                required: true
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "google-saml-certificate",
                label: "Certificate (X.509 Certificate)",
                value: certificate,
                onChange: onCertificateChange,
                rows: 6,
                placeholder: "-----BEGIN CERTIFICATE----- MIIDdDCCAlygAwIBAgIGAY... -----END CERTIFICATE-----",
                helpText: "Paste the full X.509 certificate from Google Workspace (including BEGIN/END lines)",
                required: true
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "google-saml-email-attribute",
                label: "Email Attribute Name",
                value: emailAttribute || 'email',
                onChange: onEmailAttributeChange,
                placeholder: "email",
                helpText: "Default is 'email'. Change if your Google Workspace uses a different attribute name."
            })
        ]
    });
}
